import './AboutUsPage.css';
import SEO from '../components/SEO';

const AboutUsPage = () => {
  return (
    <div className="about-page">
      <SEO
        title="About Sprout Academy | Mission, Values, and Vision"
        description="Learn why Sprout Academy was built, what we stand for, and how we create engaging curriculum-aligned adventures for children."
        path="/about"
      />
      <main className="about-page__main">
        <header className="about-page__header">
          <h1>About Sprout Academy</h1>
        </header>

        <section className="about-page__section">
          <h2>Why I built Sprout</h2>
          <p>The idea for Sprout Academy was born out of watching my own daughter and her interactions with technology. I found that all apps that she loved to spend time on weren't educational and great for me as a parent, and apps I liked as a parent weren't engaging for her. 
            I searched for days trying to find something that could be both fun for her and approved by me, but there's a surprising lack of high quality educational games.</p>
          <p>So I learnt game development and began the long road that has led to Sprout Academy.</p>
        </section>

        <section className="about-page__section">
          <h2>What we stand for</h2>
          <ul className="about-page__values">
            <li>
              <strong>Adventure:</strong> Story, progression, and captivating gameplay. Children stay engaged because they're having fun, not because we've engineered dopamine hits.
            </li>
            <li>
              <strong>Parent feedback:</strong> Parents get weekly updates showing exactly which curriculum objectives their child has mastered, and how to best support their learning outside the app.
            </li>
            <li>
              <strong>Curriculum alignment:</strong> Every quest teaches a specific, named curriculum objective. No vagueness. No compromise.
            </li>
          </ul>
        </section>

        <section className="about-page__section">
          <h2>Where we're going</h2>
          <p>
            We're launching with maths for years 1 - 3. Science, English, Welsh, history, and art are in development. Eventually, Sprout Academy will become an alternative learning tool for parents who want substance behind the screen time.
          </p>
          <p>
            This is just the beginning.
          </p>
        </section>
      </main>
    </div>
  );
};

export default AboutUsPage;
